import React from 'react';
import Drawer from './Drawer.jsx';
import Rimg from './Rimg.jsx';
import loadjs from 'loadjs';
import ProductContext from './ProductContext.jsx';
import SVG from './SVG.jsx';
import { formatMoney } from '@shopify/theme-currency';
import MediaQuery from 'react-responsive';
import FitFinderForm from './FitFinderForm.jsx';

const sanitizeHtml = html => {
  const tempEl = document.createElement('div');
  tempEl.innerHTML = html;
  return { __html: tempEl.innerHTML }
}

class HonestPricing extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false };

    this._close = this._close.bind(this);
  }

  _close() {
    this.setState({ open: false })
  }

  render() {
    const DrawerHeading = <React.Fragment>
      {this.props.checkmark && <svg className="svg-icon icon-check" xmlns="http://www.w3.org/2000/svg">
        <use xlinkHref="#reuse-check"></use>
      </svg>}
      <div className="promo-heading-inline" dangerouslySetInnerHTML={sanitizeHtml(this.props.drawer_heading)} />
    </React.Fragment>
    return <React.Fragment>
      <div className="product-block-honest_pricing">
        <a className="promo-heading" onClick={(e) => { this.setState({ open: true }) }}>
          {this.props.checkmark && <svg className="svg-icon icon-check" xmlns="http://www.w3.org/2000/svg">
            <use xlinkHref="#reuse-check"></use>
          </svg>}
          <div className="promo-heading-inline" dangerouslySetInnerHTML={sanitizeHtml(this.props.heading)} />
        </a>
      </div>
      <Drawer open={this.state.open} content={this.props.drawer_content} heading={DrawerHeading} contentClass="pricing-philosophy pricing-philosophy-how-we-do-it afterpay-drawer" _close={this._close} mountOnEnter={true} unmountOnExit={true}>
        {this.props.metafields.philosophy.inlineImage &&
          <React.Fragment>
            <Rimg {...this.props.metafields.philosophy.inlineImage} loading="lazy" className="pricing-philosophy-img" />
            <SVG icon="pricing-philosophy" />
          </React.Fragment>}
      </Drawer>
    </React.Fragment>
  }
}

class HonestPricing2 extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false };

    this._close = this._close.bind(this);
  }

  _close() {
    this.setState({ open: false })
  }

  render() {
    const DrawerHeading = <React.Fragment>
      {this.props.checkmark && <svg className="svg-icon icon-check" xmlns="http://www.w3.org/2000/svg">
        <use xlinkHref="#reuse-check"></use>
      </svg>}
      <div className="promo-heading-inline" dangerouslySetInnerHTML={sanitizeHtml(this.props.drawer_heading)} />
    </React.Fragment>
    return <React.Fragment>
      <div className="product-block-honest_pricing_2">
        <div className="promo-heading" onClick={(e) => { this.setState({ open: true }) }}>
          {[1, 2, 3].map(x => {
            const icon = this.props[`icon_${x}`];
            return <div className="honest_pricing_heading" key={x}>
              {icon && <svg className={`svg-icon icon-${icon}`} xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref={`#reuse-${icon}`}></use>
              </svg>}
              {this.props[`heading_${x}`] && <div className="promo-heading-inline" dangerouslySetInnerHTML={sanitizeHtml(this.props[`heading_${x}`])} />}
            </div>
          })}
        </div>
      </div>
      {this.props.drawer_content &&
        <Drawer open={this.state.open} content={this.props.drawer_content} heading={DrawerHeading} contentClass="pricing-philosophy pricing-philosophy-how-we-do-it afterpay-drawer" _close={this._close} mountOnEnter={true} unmountOnExit={true}>
          {this.props.metafields.philosophy.inlineImage &&
            <React.Fragment>
              <Rimg {...this.props.metafields.philosophy.inlineImage} loading="lazy" className="pricing-philosophy-img" />
              <SVG icon="pricing-philosophy" />
            </React.Fragment>}
        </Drawer>
      }
    </React.Fragment>
  }
}

class FitFinder extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false };
    this._openFitFinder = this._openFitFinder.bind(this);
    this._close = this._close.bind(this);
  }

  _openFitFinder(e) {
    e.preventDefault();

    window.heap && window.heap.track('Opened Quiz', {handle: this.props.product.handle, vendor: this.props.product.vendor});

    this.setState({ open: true });
  }

  _close() {
    this.setState({ open: false })
  }

  render() {
    return <React.Fragment>
      <a href="#" onClick={this._openFitFinder}>{this.context.i18n.fitFinderTrigger}</a>
      <Drawer open={this.state.open} _close={this._close} mountOnEnter={true} unmountOnExit={false}>
        <FitFinderForm product={this.props.product} _optionChanged={this.props._optionChanged} closeFitFinder={this._close} _openSizeGuide={this.props._openSizeGuide} />
      </Drawer>
    </React.Fragment>
  }
}

FitFinder.contextType = ProductContext;

class SizeGuide extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false };
    this._open = this._open.bind(this);
    this._close = this._close.bind(this);
  }

  _open(e) {
    e.preventDefault();

    this.setState({ open: true });
  }

  _close() {
    this.setState({ open: false });
  }

  render() {
    return <React.Fragment>
      <a href="#" onClick={this._open}>{this.context.i18n.sizeGuideTrigger}</a>
      <Drawer open={this.state.open} content={this.props.sizeGuideHtml} _close={this._close} mountOnEnter={false} unmountOnExit={true} />
    </React.Fragment>
  }
}

class Measurements extends React.PureComponent {
  constructor(props) {
    super();

    this.fitFinderTrigger = this.fitFinderTrigger.bind(this);
    this.icon = this.icon.bind(this);
  }

  fitFinderTrigger() {
    if (this.props.fit_finder_trigger) {
      return <FitFinder product={this.props.product} _openSizeGuide={this.props._openSizeGuide} _optionChanged={this.props._optionChanged} />
    } else if (this.props.measurement_trigger && this.props._openSizeGuide) {
      return <a href="#" onClick={this.props._openSizeGuide}>{this.context.i18n.sizeGuideTrigger}</a>
    } else if (this.props.measurement_trigger && this.props._openFitGuide) {
      return <a href="#" onClick={this.props._openFitGuide}>{this.context.i18n.fitGuideTrigger}</a>
    }
    return null;
  }

  icon() {
    if (this.props.position === 'above-atc') {
      <SVG icon="ruler" />
    }
    return null
  }

  render() {
    if (!this.props.heading) {
      return null;
    }
    return <div className={`product-block product-block-measurements product-block-position-${this.props.position}`}>
      <this.icon />
      <div className="product-block-inline" dangerouslySetInnerHTML={{ __html: this.props.heading }} />
      {' '}
      <this.fitFinderTrigger />
    </div>
  }
}

Measurements.contextType = ProductContext;

class ReviewsSummary extends React.PureComponent {
  constructor(props) {
    super();
  }

  scrollToReviews() {
    const yotpoEl = document.querySelector('[data-yotpo-url]');
    if (yotpoEl) {
      yotpoEl.scrollIntoView({ behavior: 'smooth' });
    }
  }

  render() {
    const fillWidth = this.props.metafields.yotpo.reviewsAverage * 20;
    if (!this.props.metafields.yotpo) {
      return null;
    }
    return <div className={`product-block product-block-position-${this.props.position}`}>
      <div className="yotpo-star-container" onClick={this.scrollToReviews}>
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="87" height="15" viewBox="0 0 87 15" version="1.1" className="review-stars">
          <g>
            <rect className="stars-fill-light" width="87" height="15"></rect>
            <rect className="stars-fill" width="87" height="15" style={{ width: fillWidth + '%' }}></rect>
            <use xlinkHref="#reuse-stars" className="icon-stars"></use>
          </g>
        </svg>
        {' '}
        <span className="yotpo-content">{this.props.metafields.yotpo.reviewsAverage} ({formatMoney(this.props.metafields.yotpo.reviewsCount * 100, '{{amount_no_decimals}}')} reviews)</span>
      </div>
    </div>
  }
}

ReviewsSummary.contextType = ProductContext;

export default class ProductPromos extends React.PureComponent {
  constructor(props) {
    super();
    this.promos = props.blocks.filter(promo => {
      if ((promo.settings.position === 'above-atc-smart' || promo.settings.position === 'above-atc-smart-2' || promo.settings.position === 'above-atc-smart-3') && props.position === 'above-atc' && props.product.options.size === 0) {
        return true;
      }
      return promo.settings.position === props.position
    });
  }

  promoText(promo, i) {
    return <div className={`product-block product-block-promo_text product-block-position-${this.props.position} ${promo.custom_class}`} key={i}>
      <div className="promo-heading" dangerouslySetInnerHTML={sanitizeHtml(promo.heading)} />
      <div className="promo-subheading" dangerouslySetInnerHTML={sanitizeHtml(promo.subheading)} />
    </div>
  }

  render() {
    return this.promos.map((promo, i) => {
      const mediaAttr = {}

      if (promo.settings.desktop === 'hide' && promo.settings.mobile === 'hide') {
        return (null)
      } else if (promo.settings.desktop === 'hide') {
        mediaAttr.maxWidth = 719;
      } else if (promo.settings.mobile === 'hide') {
        mediaAttr.minWidth = 720;
      } else {
        mediaAttr.minWidth = 0;
      }

      switch (promo.type) {
        case "promo_text":
          return this.promoText(promo.settings, i)
        case "honest_pricing":
          return <MediaQuery {...mediaAttr} key={i}>
            <HonestPricing {...promo.settings} metafields={this.props.metafields} />
          </MediaQuery>
        case "honest_pricing_2":
          return <MediaQuery {...mediaAttr} key={i}>
            <HonestPricing2 {...promo.settings} metafields={this.props.metafields} />
          </MediaQuery>
        case "reviews":
          return <MediaQuery {...mediaAttr} key={i}>
            <ReviewsSummary {...promo.settings} metafields={this.props.metafields} />
          </MediaQuery>
        case "measurements":
          return <MediaQuery {...mediaAttr} key={i}>
            <Measurements {...promo.settings} product={this.props.product} _openSizeGuide={this.props._openSizeGuide} _openFitGuide={this.props._openFitGuide} _optionChanged={this.props._optionChanged} />
          </MediaQuery>
      }
    })
  }
}